import React, { Component } from 'react';
import HtmlHelpers from '../../HtmlHelpers';
export default class WmForm extends Component {
  constructor(props) {
    super(props);
    this.setForm = form => {
      this.formEl = form;
      return form;
    };
    this.validate = () => HtmlHelpers.validateForm(this.formEl);
    this.submitHandler = event => {
      event.preventDefault();
      if (this.validate()) {
        this.props.submit(this);
      }
      this.setState({
        isValidated: true
      });
    };
    this.state = {
      isValidated: false
    };
  }
  render() {
    let props = {};
    if (typeof this.props[Symbol.iterator] === 'function') {
      props = [...this.props];
    }
    let classNames = [];
    if (props.className) {
      classNames = [...props.className];
      delete props.className;
    }
    if (this.state.isValidated) {
      classNames.push('was-validated');
    }
    return /*#__PURE__*/React.createElement("form", Object.assign({}, props, {
      id: this.props.id,
      className: classNames,
      ref: this.setForm,
      onSubmit: this.submitHandler
    }), this.props.children);
  }
}